import { Node, SelectionNode } from 'data/types'
import React from 'react'
import Markdown from 'react-markdown'
import Dropdown from 'scenes/ExtraKYC/Dropdown'
import SingleInputSelection from 'scenes/ExtraKYC/SingleInputSelection'
import styled from 'styled-components'
import { color } from 'utils'

import MultiSelect from '../MultiSelect'
import SingleCheckbox from '../SingleCheckbox'

const InfoWrapper = styled.div`
  font-size: 13px;
  border-radius: 8px;
  border: 1px dashed rgb(255, 217, 214);
  padding: 16px;

  a {
    text-decoration: none;
    font-weight: bold;
    color: ${color('blue400')};
  }
`

const uncheckAll = (nodes: Array<SelectionNode>) => {
  if (!nodes) return nodes
  const newChildren: Array<SelectionNode> = []
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i]
    newChildren.push({
      ...node,
      checked: false
    })
  }
  return newChildren
}

const updateNode = (nodes: Array<Node>, node: Node): Array<Node> => {
  if (!nodes) return nodes
  const indexOfTarget = nodes.findIndex((o) => o.id === node.id)
  if (indexOfTarget < 0) return nodes

  const newChildren = [...nodes]
  newChildren[indexOfTarget] = node
  return newChildren
}

type Props = {
  onChange: (option: Array<Node>) => void
  question: Node
}
const Question = ({ onChange, question }: Props) => {
  if (question.type === 'MULTIPLE_SELECTION') {
    if (question.children.length > 5) {
      return <MultiSelect options={question.children} onChange={onChange} />
    }

    return (
      <SingleInputSelection
        onChange={(option) => onChange(updateNode(question.children, option))}
        options={question.children}
      />
    )
  }

  if (question.type === 'SINGLE_SELECTION') {
    if (question.isDropdown) {
      return (
        <Dropdown
          options={question.children}
          onChange={(option) => onChange(updateNode(uncheckAll(question.children), option))}
        />
      )
    }

    return (
      <SingleInputSelection
        singleSelection
        onChange={(option) => onChange(updateNode(uncheckAll(question.children), option))}
        options={question.children!}
      />
    )
  }

  if (question.type === 'SINGLE_CHECKBOX') {
    return <SingleCheckbox question={question} onChange={onChange} />
  }

  if (question.type === 'INFO') {
    return (
      <InfoWrapper>
        <Markdown linkTarget='_blank'>{question.description}</Markdown>
      </InfoWrapper>
    )
  }

  return null
}

export default Question
